export default {
  en: {
    tabs: {
      overview: 'Overview',
      suppliers: 'Suppliers',
      about: 'About',
    },
    dataTableColumns: {
      name: 'Supplier name',
      compliance: 'Compliance',
      approvalStatus: 'Approval status',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'PII',
      assignedUsers: 'Assigned',
      dateAdded: 'Date added',
      companyNumber: 'Company number',
      country: 'Country',
      managed: 'RL managed',
      sector: 'Sector',
      website: 'Website',
      exemptionsApplied: 'Exemptions applied',
      nonComplianceApplied: 'Non-compliances applied',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      approvalExpiresAt: 'Approval expiry',
      numRisks: 'Open risks',
    },
    filterAttributes: {
      name: 'Name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      managed: 'RL managed',
      managedTrue: 'is managed',
      managedFalse: 'is not managed',
      percentageCompliance: 'Compliance',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'Holds PII',
      approvalStatus: 'Approval status',
      approved: 'Approved',
      rejected: 'Rejected',
      pending_biz: 'Pending business',
      approvedExpiry: 'Approval expired',
      inreview: 'In review',
      unapproved: 'Unapproved',
      approvalModifiedAt: 'Approval last modified',
      approvalExpiresAt: 'Approval expiry',
      createdAt: 'Date added',
      sectorID: 'Sector',
      assignedUsers: 'Assigned users',
      numExemptionsApplied: 'Number of exemptions applied',
      numNonComplianceApplied: 'Number of non compliances applied',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      numRisks: 'Open risks',
      dateAdded: 'Date added',
    },
    placeholders: {
      emptyTitle: 'Sub-entity suppliers',
      emptyDescription: 'No sub-entity suppliers could be found',
      errorTitle: 'Sub-entity suppliers',
      errorDescription: 'Failed fetching sub-entity suppliers',
    },
    misc: {
      managedLabel: 'RL managed',
      managedDescription: 'This profile has been created and is managed by Risk Ledger.',
      filterResultsSuppliers: '{count} suppliers | {count} supplier | {count} suppliers',
      filterResultsOutOf: '{0} out of {1}',
      entityName: 'Suppliers',
      export: 'Export',
      exportError: 'There was an error attempting to export the supplier list.',
    },
    totalSuppliers: {
      title: 'Total suppliers',
      help: 'Number of organisations directly supplying {org}.',
    },
    averageCompliance: {
      title: 'Average compliance',
      help: "Average compliance of all direct suppliers, determined by {org}'s policies and its suppliers' assessments.",
    },
    approvedSuppliers: {
      title: 'Approved supplier | Approved suppliers',
      help: 'Number of suppliers that {org} has reviewed and approved.',
    },
    rejectedSuppliers: {
      title: 'Rejected supplier | Rejected suppliers',
      help: 'Number of suppliers that {org} has reviewed and rejected.',
    },
    minor: 'Minor',
    important: 'Important',
    critical: 'Critical',
    unknown: 'Unknown',
    overviewFailed: 'Failed to get overview data. Please retry or contact Risk Ledger support.',
    retry: 'Retry',
  },
};
